// Common styles for AlertList components
// Color: slate-700 from tailwind.config.js
const SLATE_700 = '#404040';

export const alertListHeadingStyle = {
  fontSize: '22px',
  lineHeight: '26px',
  fontWeight: '800',
  fontFamily: 'MaryAnn, Trebuchet MS, Arial, Helvetica, sans-serif',
  color: SLATE_700
};

// Unused
export const alertListItemBorderStyle = {
  border: '1px solid black'
};
